import { SearchContainerTypes, SearchPropTypes } from '@components'
import styled, { css } from 'styled-components'
import { COLORS, inputState } from '@styles'

import { to } from '@theme'

export const SearchStyles = styled.div<SearchContainerTypes>`
  width: 100%;
  max-height: 3.4rem;

  display: flex;
  align-items: center;

  background: ${COLORS.white};
  border: 0.1rem solid ${({ theme }) => theme.palette.grey.A700};
  border-radius: 0.4rem;

  transition: all 0.2s;

  .MuiIconButton-root {
    color: ${COLORS.dark};
  }

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      max-width: 100%;
    `}

  ${({ error }) =>
    error &&
    css`
      ${inputState.error(error)}
      .MuiIconButton-root {
        color: ${COLORS.danger};
      }
    `}

  ${({ success }) =>
    success &&
    css`
      ${inputState.success(success)}
      .MuiIconButton-root {
        color: ${COLORS.success};
      }
    `}

  ${({ focused }) => inputState.focused(focused)}
  ${({ hovered }) => inputState.hovered(hovered)}
  ${({ focused }) => inputState.focused(focused)}


  ${to.lg} {
    width: 100%;
    min-width: 5rem;
  }
`

export const SearchInputStyles = styled.input<SearchPropTypes>`
  border: none;
  background-color: transparent;
  padding-left: 1rem;
  width: inherit;
  height: inherit;
  transition: all 0.2s;
  height: 100%;

  ::placeholder {
    transition: all 0.2s;

    ::first-letter {
      text-transform: uppercase;
    }
  }
`
